import toastr from 'toastr';

toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: true,
    //progressBar: true,
    positionClass: 'toast-top-right',
    onclick: null,
    showDuration: '300',
    hideDuration: '1000',
    preventDuplicates: true,
    timeOut: '7000',
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
};

export function showMessage(title, message, type, position = 'toast-top-right') {
    // Salva a configuração atual
    const currentOptions = { ...toastr.options };

    // Define a nova posição apenas para esta chamada
    toastr.options.positionClass = position;
    toastr[type](message, title);

    // Restaura as configurações originais
    toastr.options = currentOptions;
}

export function showMessageError(title, message, position) {
    if (title == null) {
        title = 'Erro';
    }

    showMessage(title, message, 'error', position);
}

export function showMessageSuccess(title, message, position) {
    if (title == null) {
        title = 'Sucesso';
    }

    showMessage(title, message, 'success', position);
}

export function showMessageAlert(title, message, position) {
    if (title == null) {
        title = 'Alerta';
    }

    showMessage(title, message, 'warning', position);
}
